export enum BookingSlotChangeReasonActionTypes {
	CancelAllSlot = "CancelAllSlot",
	None = "None"
}
